<div class="profile-layout">
  <app-header></app-header>
  <main class="profile-layout__content">
    <!-- Mobile menu overlay -->
    <div class="profile-layout__overlay" [class.active]="isMobileMenuOpen" (click)="closeMobileMenu()"></div>

    <div class="profile-layout__container">
      <app-side-menu [class.mobile-open]="isMobileMenuOpen" (menuItemClick)="closeMobileMenu()" (closeMenu)="closeMobileMenu()"></app-side-menu>
      <div class="profile-layout__main">
        <!-- Mobile-only navigation dropdown (replaces the duplicate burger
             that used to live at the top of the main content). -->
        <div class="profile-layout__mobile-nav">
          <select
            class="profile-layout__mobile-nav-select"
            [ngModel]="currentMobileNav"
            (ngModelChange)="onMobileNavChange($event)"
            [attr.aria-label]="'nav.yourProfile' | transloco">
            <option *ngFor="let route of mobileNavRoutes" [ngValue]="route.value">
              {{ route.labelKey | transloco }}
            </option>
          </select>
          <i class="fas fa-chevron-down profile-layout__mobile-nav-chevron" aria-hidden="true"></i>
        </div>

        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
  <app-footer></app-footer>
  <app-toast></app-toast>
</div>
